
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 341.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 0h512v341.3H0z"}}),_c('g',{attrs:{"fill":"#6DA544"}},[_c('path',{attrs:{"d":"M0 0h512v48.8H0zM0 97.5h512v48.8H0zM0 195h512v48.8H0zM0 292.6h512v48.8H0z"}})]),_c('path',{attrs:{"fill":"#D80027","d":"M0 0h256v146.3H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M116.9 114.4l-7.5-14.8V69.9L128 59l18.6 10.9v22.3l7.4-7.4 4.2 3-4.2 11.8-14.9 14.8z"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"82","cy":"82.8","r":"5.4"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"90.8","cy":"61.7","r":"5.4"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"106.6","cy":"46.2","r":"5.4"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"128","cy":"40.8","r":"5.4"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"149.4","cy":"46.2","r":"5.4"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"165.2","cy":"61.7","r":"5.4"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"174","cy":"82.8","r":"5.4"}})])
          )
        }
      }
    